import { Component, Context, h } from 'preact';
import { IntlContext } from 'preact-i18n';
import { DASH, Price, Properties, WidgetTab } from '../../common';
import { Column } from '../../common/Layout/Layout';
import { formatPrice, PriceFormatOptions, IntlContextWithDictionary, FinText } from '../../i18n';
import { BookingState, connectStore } from '../../store';

export interface StartingPriceProps extends Properties {}

interface StoreProps {
  startingFrom: Price;
  currentTab: WidgetTab;
}

type EffectiveProps = StartingPriceProps & StoreProps;

const mapStateToProps = ({ price: { startingFrom }, currentTab }: BookingState): StoreProps => {
  return {
    startingFrom,
    currentTab,
  };
};

const startingPriceFormatOptions: PriceFormatOptions = {
  round: true,
  showSymbol: true,
  showThousandSeparators: true,
};
@connectStore({ mapStateToProps })
export default class StartingPrice extends Component<StartingPriceProps> {
  static contextType: Context<IntlContextWithDictionary> = IntlContext;

  render({ currentTab, startingFrom }: EffectiveProps): h.JSX.Element {
    const formattedPrice = formatPrice(startingFrom, startingPriceFormatOptions, this.context) || DASH;
    const longPrice: boolean = String(formattedPrice).length > 8;

    return (
      <Column class={this.props.class} vCenter={false}>
        <div class="nordic-blue-900-text font-body-1 regular-type">
          <FinText id={currentTab === WidgetTab.AM ? 'aurinkomatkat.priceText' : 'startingPrice.title'} />
        </div>
        <div className={`nordic-blue-900-text bold-type ${longPrice ? 'font-heading-5' : 'font-heading-4'}`}>
          {formattedPrice}
        </div>
      </Column>
    );
  }
}
